import {NgModule} from "@angular/core";
import {AksjeeierbokComponentAvhengigheter} from "./komponenter/aksjeeierbok/aksjeeierbok";
import {AksjeeierRedigerDialogKomponentAvhengigheter} from "web-ng2/moduler/aksjeeierbok/modale/aksjeeier-rediger-dialog/aksjeeier-rediger-dialog";
import {OpprettAksjeeierDialogKomponentAvhengigheter} from "web-ng2/moduler/aksjeeierbok/modale/aksjeeier-opprett-dialog/opprett-aksjeeier-dialog";
import {AksjeeierKomponentAvhengigheter} from "web-ng2/moduler/aksjeeierbok/komponenter/aksjeeier/aksjeeier";
import {AksjeeiereRedigerBeholdningDialogKomponentAvhengigheter} from "web-ng2/moduler/aksjeeierbok/modale/aksjeeiere-rediger-beholdning-dialog/aksjeeiere-rediger-beholdning-dialog";
import {AksjeeierRedigerKomponentAvhengigheter} from "web-ng2/moduler/aksjeeierbok/komponenter/aksjeeier-rediger/aksjeeier-rediger";
import {AksjeeiereSlettSisteBeholdningsendringDialogKomponentAvhengigheter} from "web-ng2/moduler/aksjeeierbok/modale/aksjeeiere-slett-siste-beholdningsendring-dialog/aksjeeiere-slett-siste-beholdningsendring-dialog";
import {AksjeeierRedigerBeholdningKommentarDialogKomponentAvhengigheter} from "web-ng2/moduler/aksjeeierbok/modale/aksjeeier-rediger-beholdning-kommentar/aksjeeier-rediger-beholdning-kommentar-dialog";
import {AksjeeierbokEksportDialogKomponentAvhengigheter} from "web-ng2/moduler/aksjeeierbok/modale/aksjeeierbok-eksport-dialog/aksjeeierbok-eksport-dialog";
import {OpprettAksjeeiereFraSkatteetatenDialogKomponentAvhengigheter} from "web-ng2/moduler/aksjeeierbok/modale/opprett-aksjeeiere-fra-skatteetaten-dialog/opprett-aksjeeiere-fra-skatteetaten-dialog";
import {OpprettAksjeeiereFraSkatteetatenOrgnummerDialogKomponentAvhengigheter} from "web-ng2/moduler/aksjeeierbok/modale/opprett-aksjeeiere-fra-skatteetaten-orgnummer-dialog/opprett-aksjeeiere-fra-skatteetaten-orgnummer-dialog";

@NgModule({
    providers: [
        AksjeeierbokComponentAvhengigheter,
        AksjeeierbokEksportDialogKomponentAvhengigheter,
        AksjeeierRedigerKomponentAvhengigheter,
        AksjeeierRedigerDialogKomponentAvhengigheter,
        AksjeeierRedigerBeholdningKommentarDialogKomponentAvhengigheter,
        OpprettAksjeeierDialogKomponentAvhengigheter,
        AksjeeierKomponentAvhengigheter,
        AksjeeiereRedigerBeholdningDialogKomponentAvhengigheter,
        AksjeeiereSlettSisteBeholdningsendringDialogKomponentAvhengigheter,
        OpprettAksjeeiereFraSkatteetatenDialogKomponentAvhengigheter,
        OpprettAksjeeiereFraSkatteetatenOrgnummerDialogKomponentAvhengigheter
    ]
})
export class AksjeeierbokModul{

}
